import echo from '../libs/echo.js';
function lazyImg(){
    echo.init({
        offset : 100,//可是区域多少像素可以被加载
        throttle : 0 //设置图片延迟加载的时间
    });
}
function localParam(search, hash) {
    search = search || window.location.search;
    hash = hash || window.location.hash;
    var fn = function(str, reg) {
        if (str) {
            var data = {};
            str.replace(reg, function($0, $1, $2, $3) {
                data[$1] = $3;
            });
            return data;
        }
    }
    return {
        search : fn(search, new RegExp("([^?=&]+)(=([^&]*))?", "g")) || {},
        hash : fn(hash, new RegExp("([^#=&]+)(=([^&]*))?", "g")) || {}
    };
}
function setScrollTop(val=0){
	setTimeout(()=>{
		document.body.scrollTop = val;
		document.documentElement.scrollTop = val;
	}, 100)
}
function getNowTime(data){
	let NowDate = new Date();
	if(data){
		NowDate = new Date(data);
	}
	let YY = NowDate.getFullYear();
	let MM = NowDate.getMonth()+1 > 9?NowDate.getMonth()+1:'0'+(NowDate.getMonth()+1);
	let DD = NowDate.getDate() > 9?NowDate.getDate():'0'+(NowDate.getDate());
	
	return YY+'-'+MM+'-'+DD
}
export {
    lazyImg,
    localParam,
    setScrollTop,
	getNowTime
}